module.exports = __webpack_public_path__ + "static/media/openapi.fab1fbf6.yaml";